import { render, staticRenderFns } from "./UTrainerFeedback.vue?vue&type=template&id=346e99b9&"
import script from "./UTrainerFeedback.vue?vue&type=script&lang=js&"
export * from "./UTrainerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports